import { useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  deleteQuestionnaireAction,
  getQuestionnairesAction,
} from '../../../../../store/actions/questionnaire.action';

const DeleteQuestionnaire = ({ isOpen, setIsOpen, filterValue }) => {
  const dispatch = useDispatch();
  const { questionnaireItem } = useSelector(
    (state) => state?.questionnaireState
  );

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleDelete = () => {
    if (questionnaireItem) {
      dispatch(
        deleteQuestionnaireAction(questionnaireItem.questionnaire_id, () => {
          handleClose();
          dispatch(getQuestionnairesAction(filterValue.condition_id));
        })
      );
    }
  };

  return (
    <Modal
      title="Delete Questionnaire"
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={400}
    >
      <div className="flex flex-col items-center py-4">
        <ExclamationCircleOutlined
          style={{ fontSize: '48px', color: '#ff4d4f', marginBottom: '16px' }}
        />
        <h3 className="text-lg font-medium mb-2">Confirm Deletion</h3>
        <p className="text-center mb-6">
          Are you sure you want to delete the questionnaire for{' '}
          {questionnaireItem?.condition_name}? This action cannot be undone.
        </p>
        <div className="flex justify-end w-full">
          <Button onClick={handleClose} className="mr-2">
            Cancel
          </Button>
          <Button type="primary" danger onClick={handleDelete}>
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteQuestionnaire;
